import { Icon } from '@chakra-ui/react';

export const SlideLeftIcon = (props: any) => (
  <Icon aria-label="slide left icon" viewBox="0 0 46 46" {...props}>
    <path
      d="M23 3c11.046 0 20 8.954 20 20s-8.954 20-20 20S3 34.046 3 23 11.954 3 23 3zm2.617 11L16 23l9.617 9L28 29.77 20.766 23 28 16.23 25.617 14z"
      fill="currentColor"
    />
  </Icon>
);
